










import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ContractGroup extends Vue {
}

